import { format } from "date-fns";
import { Formik } from "formik";
import { useContext } from "react";
import { UserContext } from "../../Context/UserContextAPI";
import useIsOneIntroducer from "../../hooks/useIsOneIntroducer";
import { cleanObject } from "../../utils/commonFunctions";
import ReactSelect from "../Inputs/ReactSelect";
import VirtualizedMenuList from "../VirtualMenuList/VirtualMenuList";
import VirtualizedMenuListPackage from "../VirtualMenuList/VirtualMenuListPackage";
import ReactInput from "./../Inputs/ReactInput";

const UserSearchForm = ({
  userSearchHandler,
  fromCollectionReport,
  isLoading,
  inlineButtonComponent,
}) => {
  const { packages, introducerUsers, countryUsers, representativeUsers } =
    useContext(UserContext);

  // custom hooks
  const isOneIntroducer = useIsOneIntroducer();

  const initialValues = {
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
    status: "",
    packageId: "",
    introducer: "",
    representative: "",
    country: "",
    company: "",
    delegate: "",
    regNo: "",
    viewOptions: fromCollectionReport ? "all" : "",
  };
  const handleSubmit = async (values) => {
    const cleanValues = cleanObject(values);
    if (userSearchHandler) {
      return userSearchHandler(cleanValues);
    }
    return null;
  };
  //   console.log("package", packages);
  const statusOptions = [
    { id: "", name: "Select Status" },
    { id: 1, name: "PROCESSING" },
    { id: 2, name: "FIT" },
    { id: 3, name: "UNFIT" },
    { id: 4, name: "HELD-UP" },
  ];

  // view Options
  const collectionReportOptions = [
    {
      value: "all",
      label: "All DATA",
    },
    {
      value: "due",
      label: "DUES Data",
    },
    {
      value: "paid",
      label: "PAID Data",
    },
  ];

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ handleSubmit, handleChange, values, resetForm, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="">
          <div className="d-flex flex-wrap">
            <div className="p-1">
              <label className="col-form-label">
                From <span className="text-danger">*</span>
              </label>
              <div className="">
                <input
                  type="date"
                  data-date-format="YYYY MM DD"
                  name="fromDate"
                  //   defaultValue={format(new Date(), "yyyy-MM-dd")}
                  className="form-control medical-form-select py-2"
                  placeholder="Date Picker..."
                  //   required={regInputField ? false : true}
                  style={{ maxWidth: "200px" }}
                  value={format(new Date(values.fromDate), "yyyy-MM-dd")}
                  onChange={(e) => setFieldValue("fromDate", e.target.value)}
                />
              </div>
            </div>
            <div className="p-1">
              <label className="col-form-label">
                To <span className="text-danger">*</span>
              </label>
              <div className="">
                <input
                  type="date"
                  data-date-format="YYYY MM DD"
                  //   defaultValue={format(new Date(), "yyyy-MM-dd")}
                  name="toDate"
                  className="form-control medical-form-select py-2"
                  placeholder="Date Picker..."
                  //   required={regInputField ? false : true}
                  style={{ maxWidth: "200px" }}
                  value={format(new Date(values.toDate), "yyyy-MM-dd")}
                  onChange={(e) => setFieldValue("toDate", e.target.value)}
                />
              </div>
            </div>
            <div className="p-1">
              <label className="col-form-label">Status</label>
              <div className="fw-light" style={{ width: "14rem" }}>
                <ReactSelect
                  name="status"
                  data={statusOptions}
                  valueName={"id"}
                  labelName={"name"}
                  onChange={(val) => setFieldValue("status", val)}
                  value={values.status}
                />
              </div>
            </div>
            <div className="p-1">
              <label className="col-form-label">Package</label>
              <div className="fw-light" style={{ width: "20rem" }}>
                <ReactSelect
                  name="packageId"
                  data={[
                    { id: "", code: "Select Package" },
                    ...packages,
                    { id: "individual", code: "Individual Package" },
                  ]}
                  valueName={"id"}
                  labelName={"code"}
                  components={{
                    MenuList: VirtualizedMenuListPackage,
                  }}
                  value={values.packageId}
                  onChange={(val) => setFieldValue("packageId", val)}
                />
              </div>
            </div>
            {!isOneIntroducer && (
              <div className="p-1">
                <label className="col-form-label">Introducer</label>
                <div className="fw-light" style={{ width: "20rem" }}>
                  <ReactSelect
                    data={[
                      { id: "", f_name: "Select Introducer" },
                      ...introducerUsers,
                    ]}
                    valueName={"id"}
                    labelName={"f_name"}
                    components={{ MenuList: VirtualizedMenuList }}
                    value={values.introducer}
                    onChange={(val) => setFieldValue("introducer", val)}
                  />
                </div>
              </div>
            )}

            <div className="p-1">
              <label className="col-form-label">Representative</label>
              <div className="fw-light" style={{ width: "20rem" }}>
                <ReactSelect
                  data={[
                    { id: "", f_name: "Select Representative" },
                    ...representativeUsers,
                  ]}
                  valueName={"id"}
                  labelName={"f_name"}
                  components={{ MenuList: VirtualizedMenuList }}
                  value={values.representative}
                  onChange={(val) => setFieldValue("representative", val)}
                />
              </div>
            </div>

            <div className="p-1">
              <label className="col-form-label">Country</label>
              <div className="fw-light" style={{ width: "20rem" }}>
                <ReactSelect
                  data={[{ id: "", f_name: "Select Country" }, ...countryUsers]}
                  valueName={"id"}
                  labelName={"name"}
                  components={{ MenuList: VirtualizedMenuList }}
                  value={values.country}
                  onChange={(val) => setFieldValue("country", val)}
                />
              </div>
            </div>

            {fromCollectionReport && (
              <div className="p-1">
                <label className="col-form-label">View Option</label>
                <div className="fw-light" style={{ width: "10rem" }}>
                  <ReactSelect
                    data={collectionReportOptions}
                    valueName={"value"}
                    labelName={"label"}
                    components={{ MenuList: VirtualizedMenuList }}
                    value={values.viewOptions}
                    onChange={(val) => setFieldValue("viewOptions", val)}
                  />
                </div>
              </div>
            )}

            <div className=" p-1">
              <label className="col-form-label tdt">
                Registration/Passport No.
              </label>
              <div className="">
                <ReactInput
                  style={{ width: "180px", height: "37px" }}
                  type="text"
                  name="regNo"
                  className=" py-2"
                  placeholder="Registration/Passport No."
                />
              </div>
            </div>
            <div className="p-1 d-flex align-items-end justify-content-end gap-1">
              <button
                type="submit"
                className="btn text-white bg-danger border border-3"
                disabled={isLoading}
              >
                {isLoading ? "Searching..." : "Search"}
              </button>
              <button
                type="button"
                className="btn btn-warning border border-3"
                onClick={() => {
                  resetForm();
                  userSearchHandler(cleanObject(initialValues));
                }}
              >
                Reset
              </button>
              {inlineButtonComponent}
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default UserSearchForm;
